// PreventiApp · Sprint 5 · Paso 2 · TanStack Query client
//
// Config:
//  - staleTime: 30s (revalidación en segundo plano tras ese lapso).
//  - gcTime:    5min en memoria (garbage collected después).
//  - refetchOnWindowFocus: false (evita spammear la BD al volver al tab).
//  - Sin persistencia en disco (queryClient in-memory por defecto).
//    Esto cumple: "no almacenar relatos, audios ni imágenes en caché persistente".
//  - Al signOut se llama `queryClient.clear()` desde AuthContext.
//
// Aislamiento por usuario/colegio/rol/modo:
//  Cada queryKey incluye [scope, userId, colegioId, rol, modo, ...params].
//  Ver `dashboardKeys` en `dashboardQueries.js`.
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
      retry: (failureCount, err) => {
        // Nunca reintentar 401/403 (permisos)
        const status = err?.status;
        if (status === 401 || status === 403) return false;
        return failureCount < 2;
      },
    },
  },
});
